export default __webpack_public_path__ + "static/media/logo-blue.629e00ff.png";